import { useRef } from 'react';

import { Box } from '@mui/material';

type Props = {
  children: React.ReactNode;
  accept: string;
  onUpload?: (files: File[]) => void;
  disabled?: boolean;
};

function Upload({ children, accept, onUpload, disabled }: Props) {
  const ref = useRef<HTMLInputElement>(null);

  const handleClick = () => {
    if (disabled) return;

    if (ref.current) {
      ref.current.click();
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files ? Array.from(e.target.files) : [];
    if (onUpload) {
      onUpload(files);
    }

    // Reset the input value to allow uploading the same file again
    if (ref.current) {
      ref.current.value = '';
    }
  };

  return (
    <Box>
      <input
        type="file"
        ref={ref}
        style={{ display: 'none' }}
        accept={accept}
        onChange={handleChange}
      />
      <Box onClick={handleClick}>{children}</Box>
    </Box>
  );
}

export default Upload;
